export async function initializeOffice(onReadyCallback: () => void): Promise<void> {
  await Office.onReady((info) => {
    console.log("Office is ready from ready.tsx");

    if (info.host === Office.HostType.Excel) {
      console.info("Canvas Excel Add-in running on Excel App.");
    } else {
      console.info("Canvas Excel Add-in running on Excel Web App on browser.");
    }
  }).then(() => {
    onReadyCallback();
  });
}
